<!-- Navbar -->
<mdb-navbar SideClass="navbar navbar-expand-lg navbar-dark unique-color" [containerInside]="false" (click)="$event.stopPropagation()" (touchend)="$event.stopPropagation()">

    <!-- Navbar brand -->
    <mdb-navbar-brand>
        <!-- <a [class.disabled]="auth.loadToken()" class="navbar-brand" [routerLink]="''" href="#"> -->
        <a class="navbar-brand" [routerLink]="''" href="#" (click)="navbar.hide()">
          <img class="logo" src="../../assets/rentwise.svg" width="425" alt="RentWise Logo">
        </a>
    </mdb-navbar-brand>

    <!-- Links for normal users-->
    <links *ngIf="!auth.getAdminStatus()">
        <ul class="navbar-nav ml-auto">

            <!-- Ask a Housing Provider -->
            <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [href]="askHousingProviderUrl" target="_blank">
                    <mdb-icon fas icon="question-circle"></mdb-icon> Ask a Housing Provider
                </a>
            </li>

            <!-- Resources -->
            <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect href="https://www.rentwise.org/resources" target="_blank">
                    <mdb-icon fas icon="globe"></mdb-icon> Resources
                </a>
            </li>

            <!-- Public Records -->
            <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/public-records'">
                    <mdb-icon fas icon="user-alt"></mdb-icon> Public Records
                </a>
            </li>

            <!-- Login -->
            <li *ngIf="!auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/login'">
                    <mdb-icon fas icon="user-alt"></mdb-icon> Login
                </a>
            </li>

            <!-- Sign Up -->
            <li *ngIf="!auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/sign-up'">
                    <mdb-icon fas icon="book"></mdb-icon> Sign Up
                </a>
            </li>

            <!-- Account Info -->
            <li *ngIf="auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/account-info'">
                    <mdb-icon fas icon="address-book"></mdb-icon> My Account
                </a>
            </li>

            <!-- Courses -->
            <li *ngIf="auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/courses'">
                    <mdb-icon fas icon="book-open"></mdb-icon> Courses
                </a>
            </li>

            <!-- Log Out -->
            <li *ngIf="auth.loadToken()" class="nav-item">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect (click)="onLogout()">
                    <mdb-icon fas icon="sign-out-alt"></mdb-icon> Log Out
                </a>
            </li>
        </ul>
    </links>

    <!-- Links for Admins -->
    <links *ngIf="auth.getAdminStatus()">
        <ul class="navbar-nav ml-auto">

            <!-- Ask a Housing Provider -->
            <li class="nav-item" [routerLinkActive]="['active']">
              <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [href]="askHousingProviderUrl" target="_blank">
                  <mdb-icon fas icon="question-circle"></mdb-icon> Ask a Housing Provider
              </a>
            </li>

            <!-- Resources -->
            <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect href="https://www.rentwise.org/resources" target="_blank">
                  <mdb-icon fas icon="globe"></mdb-icon> Resources
                </a>
            </li>

            <!-- Public Records -->
            <li class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/public-records'">
                    <mdb-icon fas icon="user-alt"></mdb-icon> Public Records
                </a>
            </li>

            <!-- Login -->
            <li *ngIf="!auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/login'">
                    <mdb-icon fas icon="user-alt"></mdb-icon> Login
                </a>
            </li>

            <!-- Sign Up -->
            <li *ngIf="!auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/sign-up'">
                    <mdb-icon fas icon="book"></mdb-icon> Sign Up
                </a>
            </li>

            <!-- Account Info -->
            <li *ngIf="auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/admin/account-info'">
                    <mdb-icon fas icon="address-book"></mdb-icon> My Account
                </a>
            </li>

            <!-- Home -->
            <li *ngIf="auth.loadToken()" class="nav-item" [routerLinkActive]="['active']">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect [routerLink]="'/admin/home'">
                    <mdb-icon fas icon="home"></mdb-icon> Home
                </a>
            </li>

            <!-- Log Out -->
            <li *ngIf="auth.loadToken()" class="nav-item">
                <a class="nav-link waves-light navbar-button mr-3" mdbWavesEffect (click)="onLogout()">
                    <mdb-icon fas icon="sign-out-alt"></mdb-icon> Log Out
                </a>
            </li>
        </ul>
    </links>
</mdb-navbar>
